import React, { useContext } from 'react';
import { SaveAsPatchContext, ISaveAsPatchContext } from '../../saveAsPatchModalState/saveAsPatchModalContext';
import { TypeOfChanges } from './components/TypeOfChanges';
import { Info } from './components/Info';
import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect';
import { PropertiesMultipleSelect } from './components/PropertiesMultipleSelect';
import { DisabledStatus } from './components/DisabledStatus';
import { BtnBlock } from './components/BtnBlock';
import style from './Forms.module.scss';

export const Forms: React.FC = () => {
	const {
		saveData,
		setTypeOfChanges,
		setIDsRestaurant,
		setProperties,
		toggleForceDisable,
		changeTypeOfModalWindow,
		initialFormData,
		typeOfChanges,
		IDsSelectedRestaurant,
		selectedProperties,
		forceDisable,
	} = useContext<ISaveAsPatchContext>(SaveAsPatchContext);

	return (
		<div className={style.container} data-test="CreateStudioModal">
			<TypeOfChanges setTypeOfChanges={setTypeOfChanges} typeOfChanges={typeOfChanges} />
			{typeOfChanges === 'basedChanges' && (
				<Info
					customerName={initialFormData.customerName}
					inclusive={initialFormData.inclusive}
					fetchedRestaurants={initialFormData.fetchedRestaurants}
					IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
					forceDisable={initialFormData.forceDisable}
				/>
			)}
			<RestaurantsMultipleSelect
				setIDsRestaurant={setIDsRestaurant}
				restaurants={initialFormData.fetchedRestaurants}
				IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
				IDsSelectedRestaurant={IDsSelectedRestaurant}
				typeOfChanges={typeOfChanges}
			/>
			<PropertiesMultipleSelect setProperties={setProperties} selectedProperties={selectedProperties} />
			{typeOfChanges === 'independentChanges' && !!selectedProperties.length && (
				<DisabledStatus
					toggleForceDisable={toggleForceDisable}
					selectedProperties={selectedProperties}
					forceDisable={forceDisable}
				/>
			)}
			<BtnBlock
				onClose={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
				onSaveAndMakeOtherChanges={() => saveData('saveAndMakeOtherChanges')}
				onSaveAndClose={() => saveData('saveAndClose')}
				disabledSave={!IDsSelectedRestaurant.length || !selectedProperties.length}
			/>
		</div>
	);
};
